import React from "react";
import styles from "./home.module.css";

const Notification = () => {
  return (
    <div className={styles.right_section}>
      <div className={styles.notify_section}>
        <h5>Notification</h5>
        <div className={styles.notify_child}>
          <img src="/images/IconSet.jpg" alt="bug" />
          <div>
            <p>You have a bug that needs to be fixed.</p>
            <span>Just Now</span>
          </div>
        </div>
        <div className={styles.notify_child}>
          <img src="/images/userSet.png" alt="user" />
          <div>
            <p>New user registered</p>
            <span>59 minutes ago</span>
          </div>
        </div>
        <div className={styles.notify_child}>
          <img src="/images/IconSet.jpg" alt="bug" />
          <div>
            <p>You have a bug that needs to be fixed.</p>
            <span>12 hours ago</span>
          </div>
        </div>
        <div className={styles.notify_child}>
          <img
            src="/images/Broadcast.jpg"
            alt="Broadcast"
            style={{ width: "20px", height: "20px" }}
          />
          <div className="ps-1">
            <p>Andi Lane subscribed to you</p>
            <span>Today, 11:59 AM</span>
          </div>
        </div>
      </div>
      <div className={styles.notify_section}>
        <h5>Activites</h5>
        <div className={styles.notify_child}>
          <img src="/images/user_1.png" alt="user" />
          <div>
            <p>You have a bug that needs to be fixed.</p>
            <span>Just Now</span>
          </div>
        </div>
        <div className={styles.notify_child}>
          <img src="/images/user_w.png" alt="user" />
          <div>
            <p>Modified A data in Page X</p>
            <span>59 minutes ago</span>
          </div>
        </div>
        <div className={styles.notify_child}>
          <img src="/images/male.png" alt="user" />
          <div>
            <p>YModified A data in Page X</p>
            <span>12 hours ago</span>
          </div>
        </div>
        <div className={styles.notify_child}>
          <img src="/images/logo.png" alt="user" />
          <div className="ps-1">
            <p>Deleted a page in Project X</p>
            <span>Today, 11:59 AM</span>
          </div>
        </div>
      </div>
      {/* ---------Contact-section---------- */}
      <div className={styles.notify_section}>
        <h5>Contact</h5>
        <div className={styles.notify_child}>
          <img src="/images/user_1.png" alt="user" />
          <p>Nishant Choudhary</p>
        </div>
        <div className={styles.notify_child}>
          <img src="/images/user_w.png" alt="user" />
          <p>Natali Craig</p>
        </div>
        <div className={styles.notify_child}>
          <img src="/images/male.png" alt="user" />
          <p>Abhishek Singh</p>
        </div>
        <div className={styles.notify_child}>
          <img src="/images/logo.png" alt="user" />
          <p>Punit Bharti</p>
        </div>
      </div>
    </div>
  );
};

export default Notification;
